import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineChatAlt } from "react-icons/hi";
import { cardStat } from "@design-system";

/** Shared message presentation for the order inbox and template details. */
export const OrderMessageCard = ({
  message,
  title,
  projectNumber,
  children,
}: {
  message: string;
  title?: string;
  projectNumber?: string;
  children?: ReactNode;
}) => {
  const { t } = useTranslation("common");
  return (
    <div className={`${cardStat} p-4 mt-4`}>
      <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
        <div className="flex items-start space-x-3">
          <HiOutlineChatAlt className="w-5 h-5 shrink-0 text-gray-900 dark:text-gray-100" />
          <h3 className="text-sm font-medium text-text">
            {title || t("message")}
          </h3>
        </div>
        {projectNumber && (
          <span className="inline-flex items-center text-xs font-medium text-secondary bg-surface-muted dark:bg-gray-700/50 px-2 py-1 rounded-full break-all">
            {t("project_number")}: {projectNumber}
          </span>
        )}
      </div>
      <div className="text-secondary whitespace-pre-wrap break-words text-sm">
        {message}
      </div>
      {children}
    </div>
  );
};
